import React from 'react';
import TextField from '@mui/material/TextField';

/**
 * Outlined text field sized to match {@link AppDateField} for filter rows.
 */
const AppFormTextField = ({ sx, ...props }) => (
  <TextField
    fullWidth
    size="small"
    variant="outlined"
    sx={sx}
    {...props}
  />
);

export default AppFormTextField;
